import React from 'react';
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types';
import {
  FormGroup,
  InputGroup,
  Button,
  ButtonToolbar,
  ControlLabel,
  FormControl,
  HelpBlock,
  Table

} from 'react-bootstrap';
import { Form, Field } from 'react-final-form';
import { required, number, positiveNumber } from '../../../forms';
import { convertFromRaw, convertToRaw, EditorState } from 'draft-js';
import { left, center, right, justify, Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import Layout from '../../../components/Layout';
import TicketAttachmentForm from './TicketAttachmentForm';
import Select from 'react-select';
import { browserHistory } from 'react-router';

const Error = ({ name }) => (
  <Field
    name={name}
    subscription={{ touched: true, error: true }}
    render={({ meta: { touched, error } }) =>
      touched && error ? <span className="alert-danger">{error}</span> : null
    }
  />
);
export const requiredField = value => (value ? undefined : <span className="alert-danger">Required</span>);
export const renderTextField= ({ input, label, type, placeholder,readOnly, meta: { touched, error, warning } }) => (
  <InputGroup>
  {label && (<ControlLabel>{label}</ControlLabel>)}
    <FormControl
      {...input}
      type={type}
      label={label}
      placeholder={placeholder}
      readOnly={readOnly}
    />
    {touched &&
        ((error && <p className="alert alert-danger">{error}</p>) ||
          (warning && <p className="alert alert-warning">{warning}</p>))}
  </InputGroup>
);
const RenderSelectInput = ({
  input,
  options,
  name,
  id,
  label,
  help,
  meta: { active, touched, error, warning },
}) => (
    <FormGroup>
      <ControlLabel>{label}</ControlLabel>
      <Select
        id={id}
        name={name}
        options={options}
        value={input.value}
        onChange={value => {
          input.onChange(value.value);
        }}
        onBlur={value => input.onBlur(value.value)}
        joinValues
      />
      {help && <HelpBlock>{help}</HelpBlock>}
      {touched &&
        ((error && <p className="alert alert-danger">{error}</p>) ||
          (warning && <p className="alert alert-warning">{warning}</p>))}
    </FormGroup>
  );

function getInitialEditorState(content) {
  if (!content) {
    return EditorState.createEmpty();
  }
  if (Object.keys(content).length === 0 && content.constructor === Object) {
    return EditorState.createEmpty();
  }
  return EditorState.createWithContent(convertFromRaw(content));
}

const StatusOptions = [
  {
    label: 'Open',
    value: '2'
  },
  {
    label: 'Pending',
    value: '3'
  },
  {
    label: 'Resolved',
    value: '4'
  },
  {
    label: 'Closed',
    value: '5'
  }
]

const PriorityOptions = [
  {
    label: 'Low',
    value: '1'
  },
  {
    label: 'Medium',
    value: '2'
  },
  {
    label: 'High',
    value: '3'
  },
  {
    label: 'Urgent',
    value: '4'
  }
]

const TypeOptions = [
  {
    label: 'Question',
    value: 'Question'
  },
  {
    label: 'Incident',
    value: 'Incident'
  },
  {
    label: 'Problem',
    value: 'Problem'
  },
  {
    label: 'Feature Request',
    value: 'Feature Request'
  },
  {
    label: 'Refund',
    value: 'Refund'
  }
]

class AddNewTicketForm extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handlegetPhoto = this.handlegetPhoto.bind(this);
    this.getBase64 = this.getBase64.bind(this)

    this.state = {
      show: false,
      imgUpload: [],
      editorState,
      pristine: true,
      editorData: { value: "" },
      photos: "",
      url_arr: [],
      domain_url:[],
      cancelDisable: false
    };
    const editorState = getInitialEditorState();
  }

  getBase64(e) {
    var file = e.target.files[0]
    let reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      this.setState({
        imgUpload: reader.result
      })
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    }
  }

  onEditorStateChange: Function = editorState => {
    this.setState({
      editorState,
      pristine: false,
    });
  };

  onBlurEvent: Function = temp => {
    let data = convertToRaw(this.state.editorState.getCurrentContent());
    this.setState({ editorData: data }, () =>
      console.log(this.state.editorData));

  }

  onSubmit = (values) => {
    let desc = "";
    if(typeof(this.state.editorData.blocks)!= "undefined" && this.state.editorData.blocks.length){
      this.state.editorData.blocks.forEach((temp_text) => {
        desc = desc + temp_text.text +"<br/>"
      })
    }
    if(this.state.url_arr.length){
      let data = {
        description: desc ? desc : 'None',
        email: values.email,
        subject:values.subject,
        phone:values.phone,
        name: values.name,
        priority: 4,
        status: 2,
        urls: this.state.url_arr,
        type: "Incident"
      }
      this.props.addTicketWithAttchment(data)
    }else{
      let data = {
        description: desc ? desc : 'None',
        email: values.email,
        subject:values.subject,
        phone:values.phone,
        name: values.name,
        priority: 4,
        status: 2,
        type: "Incident"
      }
    this.props.addTicket(data)
    }  
  }

  handleClose() {
    browserHistory.push(`/support`);
  }

  handleShow() {
    this.setState({ show: true });
  }
  handleDeletePhoto = (url) =>{
  let idx = url.indexOf('/i')
  let temp_url = url.substr(url.indexOf('/m'),url.length)
  temp_url = '/catchfiles'+temp_url  
  let array = [...this.state.url_arr];
  let array2 = [...this.state.domain_url];
  let index = array.indexOf(temp_url)
  let index2 = array2.indexOf(url)
    if (index !== -1 && index2 !== -1) {
      array.splice(index, 1);
      array2.splice(index2, 1);
      this.setState({
        url_arr: array,
        domain_url: array2
      })
    }
  }

  handlegetPhoto(values) {
    var file = values.photo
    //let img = ''
    let temp_data = {}
    let reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
     temp_data.img = reader.result
     this.setState({cancelDisable: true})
     this.props.uploadImage(temp_data, (response) => {
      if(this.state.url_arr && Object.keys(this.state.url_arr)){
        this.setState(prevState => ({
          url_arr: [...prevState.url_arr, response.url],
          domain_url: [...prevState.domain_url, response.domain_url]
        }))
       }
       this.setState({cancelDisable: false})
    })
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    }
  }

  render() {
    const errors = {};
    const pristine = "";
    const { editorState } = this.state;
    const auth = JSON.parse(sessionStorage.getItem('auth'));
    const email = auth.profile.user.email;
    const Name = auth.profile.user.first_name + ' ' + auth.profile.user.last_name;
    const mobile = auth.profile.mobile
    return (
     <Layout>
      <div className="row">
        <div className="col-md-11">
          <h1 className="hotel-detail-subhead">
            Add New Ticket
          </h1>
        </div>

              <Form
                onSubmit={this.onSubmit}
                initialValues={{name: Name,email:email,phone:mobile}}
                render={({ handleSubmit, pristine, invalid,Name,initialValues }) => (
                  <form onSubmit={handleSubmit} >
                    <div>
                      <div>
                        <FormGroup>
                          <Field
                            name="name"
                            type="text"
                            component={renderTextField}
                            label="Name"
                            placeholder=""
                            bsClass="hotel-highlight"
                            readOnly={true}
                          />
                        </FormGroup>  
                      </div>
                      <div>    
                        <FormGroup>
                          <Field
                            name="email"
                            type="text"
                            component={renderTextField}
                            label="Email"
                            placeholder=""
                            bsClass="hotel-highlight"
                            readOnly={true}
                          />
                        </FormGroup>
                      </div>
                      <div>    
                        <FormGroup>
                          <Field
                            name="phone"
                            type="text"
                            component={renderTextField}
                            label="Phone"
                            placeholder=""
                            bsClass="hotel-highlight"
                            readOnly={true}
                          />
                        </FormGroup>
                      </div>
                      <div>    
                        <FormGroup>
                          <Field
                            name="subject"
                            type="text"
                            component={renderTextField}
                            label="Subject"
                            placeholder=""
                            bsClass="hotel-highlight"
                            validate={requiredField}
                          />
                        </FormGroup>
                      </div>
                      {/* <div>
                        <FormGroup>
                          <Field
                            name="status"
                            component={RenderSelectInput}
                            label="Status"
                            options={StatusOptions}
                            validate={requiredField}
                          />
                        </FormGroup>
                      </div>
                      <div>
                        <FormGroup>
                          <Field
                            name="priority"
                            component={RenderSelectInput}
                            label="Priority"
                            options={PriorityOptions}
                            validate={requiredField}
                          />
                        </FormGroup>
                      </div>
                      <div>
                        <FormGroup>
                          <Field
                            name="type"
                            component={RenderSelectInput}
                            label="Type"
                            options={TypeOptions}
                            validate={requiredField}
                          />
                        </FormGroup>
                      </div> */}
                      <div className="row">
                        <div className="col-md-12 hotel-details-description">
                          <h4 className="hotel-highlight">Description</h4>

                          <Editor
                            editorState={editorState}
                            toolbarClassName="toolbarClassName"
                            wrapperClassName="wrapperClassName"
                            editorClassName="editorClassName"
                            toolbar={{
                              options: ['inline', 'blockType', 'list', 'textAlign', 'history'],
                              inline: {
                                options: ['bold', 'italic', 'underline'],
                              },
                              blockType: {
                                options: ['Normal', 'H1', 'H2'],
                                className: 'fontSizeDrop',
                              },
                              textAlign: {
                                options: ['left', 'center', 'right'],
                              },
                            }}
                            onEditorStateChange={this.onEditorStateChange}
                            onBlur={this.onBlurEvent}
                          />
                        </div>
                      </div>
                       <div className="row">
                        <TicketAttachmentForm
                          {...this.props}
                          handleClose={this.handleClose}
                          handlegetPhoto={this.handlegetPhoto}
                          domain_url={this.state.domain_url}
                          handleDeletePhoto = {this.handleDeletePhoto}
                        />
                      </div>
                       

                      {errors !== undefined && errors.FORM_ERROR && (
                        <p className="alert alert-danger">{errors.FORM_ERROR}</p>
                      )}
                      {errors !== undefined && errors.note && (
                        <p className="alert alert-danger">{errors.note}</p>
                      )}
                      <FormGroup>
                        <ButtonToolbar className="ismiddle">
                          <Button
                            disabled={this.state.cancelDisable}
                            bsStyle="success"
                            type="submit"

                          >
                            Save
                                </Button>
                          <Button
                            disabled={this.state.cancelDisable}
                            bsStyle="success"
                            onClick={this.handleClose}
                          >
                            Cancel
                                </Button>
                        </ButtonToolbar>
                      </FormGroup>
                    </div>
                  </form>
                )}
              />
      </div>
    </Layout>                     
    );
  }
}



export default AddNewTicketForm;
  //render(<Example />);


// WEBPACK FOOTER //
// src/routes/support/components/AddNewTicketForm.js